/**
 * Pure client-side validation for the admin New/Edit Plan form.
 * Mirrors the server-side rules in backend/src/routes/admin/plans.js
 * (validatePlanInput) so the admin sees the same errors before submitting,
 * instead of only finding out via a raw 400 response.
 */

/**
 * @param {{ price_paise: string|number, max_users: string|number, gst_percentage?: string|number }} form
 * @returns {{ priceError: string|null, maxUsersError: string|null, gstError: string|null }}
 */
export function getPlanFormErrors(form) {
  const priceError = form.price_paise !== '' && Number(form.price_paise) < 0
    ? 'Price per User cannot be negative'
    : null;
  const maxUsersError = form.max_users !== '' && Number(form.max_users) < 0
    ? 'Maximum Users cannot be negative'
    : null;
  const gstError = form.gst_percentage !== '' && form.gst_percentage != null &&
    (Number(form.gst_percentage) < 0 || Number(form.gst_percentage) > 100)
    ? 'GST % must be between 0 and 100'
    : null;
  return { priceError, maxUsersError, gstError };
}
